import { baseAction } from "../IActionBase";
import { IMonHocSoDiem } from './../../../models/response/so-diem/IMonHocSoDiem';
import { eMonHocSoDiemActionIds } from './../../action-types/so-diem/IMonHocSoDiem';

export const monHocSoDiemActions = {
    loadStart: () => baseAction(eMonHocSoDiemActionIds.LOAD_START, undefined),
    loadSuccess: (data: IMonHocSoDiem[]) => baseAction(eMonHocSoDiemActionIds.LOAD_SUCCESS, data),
    loadError: (message: string) => baseAction(eMonHocSoDiemActionIds.LOAD_ERROR, message),
}